import { useEffect, useRef } from "react";
import axios from "axios";
import api, { API } from "@/lib/api";

export const formatCp = (v) => v.replace(/[^\d-]/g, "").replace(/^(\d{4})(\d)/, "$1-$2").slice(0, 8);

const teamLookup = (cp) => api.get(`/postal/${cp}`);
export const portalLookup = (token, session) => (cp) =>
  axios.get(`${API}/portal/${token}/postal/${cp}`, { headers: { "X-Portal-Session": session } });

// Com o código postal completo, preenche a cidade — sem apagar uma cidade escrita à mão.
export function usePostalCity(cp, city, setCity, lookup = teamLookup) {
  const auto = useRef("");
  useEffect(() => {
    if (!/^\d{4}-\d{3}$/.test(cp || "")) { return; }
    if (city && city !== auto.current) { return; }
    let live = true;
    lookup(cp).then(({ data }) => {
      if (live && data.city) { auto.current = data.city; setCity(data.city); }
    }).catch(() => {});
    return () => { live = false; };
  }, [cp]); // eslint-disable-line react-hooks/exhaustive-deps
}
